// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"ce1feee8faa2aa37","5285":"7eb0ad1d7196ecf6"}[chunkId] + ".css";
};